import React from "react";
import styled from "styled-components";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #222;
  line-height: 1.7;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
`;

const Updated = styled.p`
  color: #888;
  font-size: 14px;
  margin-bottom: 40px;
`;

const Section = styled.section`
  margin-bottom: 32px;
`;

const H2 = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const P = styled.p`
  font-size: 15px;
  margin-bottom: 12px;
`;

const Ul = styled.ul`
  padding-left: 20px;
  margin-bottom: 12px;
  li {
    font-size: 15px;
    margin-bottom: 6px;
  }
`;

const Terms = () => {
  return (
    <Container>
      <Title>이용약관</Title>
      <Updated>시행일: 2026년 3월 11일</Updated>

      <Section>
        <H2>제1조 (목적)</H2>
        <P>
          본 약관은 DP Wallet(이하 "회사")이 제공하는 서비스(이하 "서비스")의
          이용 조건 및 절차, 회사와 이용자 간의 권리·의무 및 책임 사항 등을 규정함을 목적으로 합니다.
        </P>
      </Section>

      <Section>
        <H2>제2조 (정의)</H2>
        <Ul>
          <li>"서비스"란 회사가 모바일 앱 및 웹을 통해 제공하는 일체의 서비스를 의미합니다.</li>
          <li>"이용자"란 본 약관에 동의하고 서비스를 이용하는 자를 의미합니다.</li>
        </Ul>
      </Section>

      <Section>
        <H2>제3조 (약관의 효력 및 변경)</H2>
        <Ul>
          <li>본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</li>
          <li>회사는 관련 법령에 위배되지 않는 범위 내에서 약관을 변경할 수 있으며, 변경 시 적용일 7일 전부터 공지합니다.</li>
          <li>변경된 약관에 동의하지 않을 경우 이용자는 서비스 이용을 중단하고 탈퇴할 수 있습니다.</li>
        </Ul>
      </Section>

      <Section>
        <H2>제4조 (회원가입 및 계정)</H2>
        <Ul>
          <li>이용자는 회사가 정한 양식에 따라 정보를 기입하고 본 약관에 동의함으로써 회원가입을 신청합니다.</li>
          <li>허위 정보를 기재하거나 타인의 명의를 도용한 경우, 회사는 가입을 거부하거나 이용을 제한할 수 있습니다.</li>
        </Ul>
      </Section>

      <Section>
        <H2>제5조 (이용자의 의무)</H2>
        <Ul>
          <li>이용자는 계정 정보를 안전하게 관리해야 하며, 이를 제3자에게 양도하거나 대여할 수 없습니다.</li>
          <li>이용자는 서비스를 불법적인 목적으로 이용해서는 안 됩니다.</li>
          <li>이용자는 관련 법령, 본 약관, 서비스 이용 안내 등을 준수해야 합니다.</li>
        </Ul>
      </Section>

      <Section>
        <H2>제6조 (회사의 의무)</H2>
        <Ul>
          <li>회사는 관련 법령과 본 약관이 금지하는 행위를 하지 않으며, 안정적인 서비스 제공을 위해 노력합니다.</li>
          <li>회사는 이용자의 개인정보를 보호하기 위해 보안 시스템을 갖추고 개인정보 처리방침을 공시합니다.</li>
        </Ul>
      </Section>

      <Section>
        <H2>제7조 (서비스의 변경 및 중단)</H2>
        <P>
          회사는 운영상 또는 기술상의 필요에 따라 서비스의 전부 또는 일부를 변경하거나 중단할 수 있으며,
          사전에 공지합니다. 다만, 불가피한 사유가 있는 경우 사후에 공지할 수 있습니다.
        </P>
      </Section>

      <Section>
        <H2>제8조 (면책 조항)</H2>
        <Ul>
          <li>회사는 이용자의 귀책사유로 인한 손해에 대해 책임을 지지 않습니다.</li>
          <li>천재지변, 전쟁, 정부 규제 등 불가항력으로 인한 서비스 중단에 대해 회사는 책임을 지지 않습니다.</li>
        </Ul>
      </Section>

      <Section>
        <H2>제9조 (계약 해지 및 탈퇴)</H2>
        <P>
          이용자는 언제든지 앱 내 설정 또는 고객센터를 통해 탈퇴를 요청할 수 있습니다.
          회사는 이용자가 본 약관을 위반한 경우 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.
        </P>
      </Section>

      <Section>
        <H2>제10조 (분쟁 해결)</H2>
        <Ul>
          <li>본 약관에 관한 분쟁은 대한민국 법률을 준거법으로 합니다.</li>
          <li>서비스 이용과 관련한 분쟁에 대해서는 회사 소재지 관할 법원을 전속 관할 법원으로 합니다.</li>
        </Ul>
      </Section>

      <Section>
        <H2>제11조 (연락처)</H2>
        <P>서비스 이용에 관한 문의: DWTdp1@gmail.com</P>
      </Section>
    </Container>
  );
};

export default Terms;
